import { createSelector } from '@reduxjs/toolkit';

import { projectAttributesByDomainSelector } from 'src/selectors/projectAttributesByDomain';
import { projectClassHierarchySelector } from 'src/selectors/projectClassHierarchy';
import { getAllInheritedAttributes } from 'src/utils/getAllInheritedAttributes';

export const projectClassAttributesSelector = (
  projectId: string,
  classIri: string
) =>
  createSelector(
    projectClassHierarchySelector(projectId),
    projectAttributesByDomainSelector(projectId),
    (hierarchyByIri, attributesByDomain) => {
      if (!classIri) {
        return {};
      }

      return getAllInheritedAttributes({
        classIri,
        hierarchyByIri,
        attributesByDomain,
      });
    }
  );
